import React, { useMemo } from 'react';
import '@op/assets/scss/pages/community/influencer.scss';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { Layout } from 'tea-component';
import { connect, useIntl } from 'umi';
import BubbleCommon, {
  communityInfluencerTitleText,
} from '@/pages/opinion/components/BubbleCommon';
import CommonFilter from '../components/CommonFilter';
import InfluencerTable from './widgets/InfluencerTable';
import InfluencerMetrics from './widgets/InfluencerMetrics';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import influencerBrandCreatorListPoint from '@op/operationLog/pages/influencerBrandCreatorList';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

const BrandCreatorList = ({
  gameInfo,
  wholeGameInfo,
  hidePageHeader,
  hideTips,
  filterInstanceId,
  defaultMediaType,
  enableSourcePageLog = true,
}: any) => {
  const { formatMessage } = useIntl();
  const filterGameInfo = useMemo(
    () => ({
      ...gameInfo,
      filterInstanceId,
    }),
    [gameInfo, filterInstanceId],
  );

  useInitBuriedPointInfo({
    buriedPoint: influencerBrandCreatorListPoint,
    triggerPagePoint: enableSourcePageLog,
  });
  return (
    <Content className="dbo-page dbo-influencer">
      <ContentBody
        isInfluencer
        hidePageHeader={hidePageHeader}
        hideTips={hideTips}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.BRAND_CREATOR_LIST })}
            operation={
              <span style={{ fontSize: 12, color: '#707070' }}>
                <BubbleCommon
                  iconStyle={{ marginLeft: 5 }}
                  tipsMap={communityInfluencerTitleText}
                >
                  {formatMessage({ id: 'Data Update' })}
                </BubbleCommon>
              </span>
            }
          />
        }
        pageName={PAGE_NAME.BRAND_CREATOR_LIST}
      >
        <CommonFilter
          isBrandList
          gameInfo={filterGameInfo}
          defaultMediaType={defaultMediaType}
        >
          {({ params, mediaType, hasKolTagsFilter }) => {
            return (
              <InfluencerTable
                mediaType={mediaType}
                params={params}
                wholeGameInfo={wholeGameInfo}
                gameInfo={filterGameInfo}
                hasKolTagsFilter={hasKolTagsFilter}
                tableDefaultSortKey={mediaType === 'stream' ? 'peak_ccv' : 'views'}
              >
                {({ selectedKeysMap, loading }) => (
                  <InfluencerMetrics
                    params={params}
                    mediaType={mediaType}
                    selectedKeysMap={selectedKeysMap}
                    tableLoading={loading}
                  ></InfluencerMetrics>
                )}
              </InfluencerTable>
            );
          }}
        </CommonFilter>
      </ContentBody>
    </Content>
  );
};

export default connect((state: { opinionCommon: any; }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(BrandCreatorList);
